import type { IStorageService } from "@/application/ports/services";
import type { SavedViewsStorage } from "@/domain/types/listView";

export class SavedViewsStorageService implements SavedViewsStorage {
  constructor(private storageService: IStorageService) {}

  read = (key: string): string | null => {
    const stored = this.storageService.get<unknown>(key);
    if (stored === null) return null;
    return typeof stored === "string" ? stored : JSON.stringify(stored);
  };

  write = (key: string, value: string): boolean => {
    try {
      this.storageService.set(key, value);
      return true;
    } catch {
      return false;
    }
  };
}
